// extracted by mini-css-extract-plugin
export default {"lds-roller":"SuspenseLoader_lds-roller__PKXZ0"};